import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Guid, isNotNil, Nillable } from '@web/utils';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import {
  DateTimeComponent,
  DetailsViewComponent,
  ExternalLinkComponent,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminBannerDataSourceService } from '../../services/admin-banner-data-source.service';
import { AdminBannerDetails } from '../../models/admin-banner-details';
import { AdminBannerStatusPipe } from '../../pipes/admin-banner-status.pipe';
import { BannerLocationTypePipe } from '../../../shared/pipes/banner-location-type.pipe';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';

@Component({
  selector: 'app-admin-banner-details',
  imports: [
    AdminBannerStatusPipe,
    BannerLocationTypePipe,
    CommonModule,
    DetailsViewComponent,
    ExternalLinkComponent,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    SpinnerFilledComponent,
    DateTimeComponent,
  ],
  templateUrl: './admin-banner-details.component.html',
  styleUrl: './admin-banner-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBannerDetailsComponent {
  private readonly bannerDataSource = inject(AdminBannerDataSourceService);

  public readonly id = input.required<Guid>();
  public readonly location = input<Nillable<BannerLocationType>>(null);

  protected readonly id$ = toObservable(this.id);
  protected readonly details$ = this.detailsSource();
  protected readonly isNotNil = isNotNil;

  private detailsSource(): Observable<AdminBannerDetails> {
    return this.id$.pipe(
      switchMap((id) =>
        this.location()
          ? this.bannerDataSource.fetchDetailsByIdAndLocation({
              id,
              location: this.location()!,
            })
          : this.bannerDataSource.fetchHeaderDetailsById({ id }),
      ),
    );
  }
}
